import React, { useState, useContext } from 'react';
import { ArrowLeftIcon, QrCodeIcon, TentIcon, DownloadIcon, CopyIcon, PercentIcon, CheckIcon, Share2Icon } from 'lucide-react';
import { FairContext } from '../../contexts/FairContext';
export function QRCodeGenerator({
  fair,
  onGenerated,
  onCancel
}) {
  const [qrSize, setQrSize] = useState(200);
  const [qrColor, setQrColor] = useState('#0066cc');
  const [isGenerated, setIsGenerated] = useState(false);
  const {
    setActiveFair
  } = useContext(FairContext);
  const handleGenerate = () => {
    // In a real app, this would generate a QR code with a specific URL
    // For this demo, we'll just simulate the generation
    setTimeout(() => {
      setIsGenerated(true);
    }, 1000);
  };
  const handleComplete = () => {
    // Update the fair to have an active QR code
    const updatedFair = {
      ...fair,
      hasQRCode: true
    };
    // Set this fair as the active fair with QR code
    setActiveFair(updatedFair);
    // Log to confirm the context is updated
    console.log('Setting active fair with QR code:', updatedFair);
    // Notify parent component
    onGenerated(fair.id);
  };
  return <div data-id="element-258">
      <div className="flex justify-between items-center mb-6" data-id="element-259">
        <div className="flex items-center" data-id="element-260">
          <button onClick={onCancel} className="mr-4 p-2 rounded-full bg-white/10 hover:bg-white/20 text-blue-300 transition-colors" data-id="element-261">
            <ArrowLeftIcon size={20} data-id="element-262" />
          </button>
          <div data-id="element-263">
            <h2 className="text-2xl font-bold text-white flex items-center" data-id="element-264">
              <QrCodeIcon className="mr-2" size={24} data-id="element-265" />
              Generate QR Code for Fair
            </h2>
            <p className="text-blue-300 mt-1" data-id="element-266">
              Create a promotional QR code for {fair.name}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-267">
        <div className="bg-white/5 backdrop-blur-sm border border-blue-800/30 rounded-xl p-6" data-id="element-268">
          <h3 className="text-lg font-medium text-white mb-4" data-id="element-269">Fair Details</h3>
          <div className="flex items-center mb-4" data-id="element-270">
            <div className="w-12 h-12 bg-amber-900/30 rounded-full flex items-center justify-center border border-amber-700/30 mr-4" data-id="element-271">
              <TentIcon className="h-6 w-6 text-amber-500" aria-hidden="true" data-id="element-272" />
            </div>
            <div data-id="element-273">
              <h4 className="text-white font-medium" data-id="element-274">{fair.name}</h4>
              <p className="text-blue-300 text-sm" data-id="element-275">{fair.location}</p>
            </div>
          </div>
          <div className="space-y-4 mt-6" data-id="element-276">
            <div data-id="element-277">
              <label className="block text-sm font-medium text-blue-300 mb-1" data-id="element-278">
                QR Code Size
              </label>
              <input type="range" min="150" max="300" step="10" value={qrSize} onChange={e => setQrSize(parseInt(e.target.value))} className="w-full h-2 bg-blue-900/50 rounded-lg appearance-none cursor-pointer" data-id="element-279" />
              <div className="flex justify-between text-xs text-blue-400 mt-1" data-id="element-280">
                <span data-id="element-281">Small</span>
                <span data-id="element-282">Large</span>
              </div>
            </div>
            <div data-id="element-283">
              <label className="block text-sm font-medium text-blue-300 mb-1" data-id="element-284">
                QR Code Color
              </label>
              <div className="flex items-center space-x-3" data-id="element-285">
                <input type="color" value={qrColor} onChange={e => setQrColor(e.target.value)} className="h-8 w-8 rounded cursor-pointer" data-id="element-286" />
                <span className="text-white" data-id="element-287">{qrColor}</span>
              </div>
            </div>
            {!isGenerated && <button onClick={handleGenerate} className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition-colors shadow-md flex items-center justify-center" data-id="element-288">
                <QrCodeIcon size={18} className="mr-2" data-id="element-289" />
                Generate QR Code
              </button>}
          </div>
        </div>
        <div className="bg-white/5 backdrop-blur-sm border border-blue-800/30 rounded-xl p-6 flex flex-col items-center justify-center" data-id="element-290">
          {isGenerated ? <div className="text-center" data-id="element-291">
              <div className="mb-6 bg-white p-4 rounded-xl inline-block" data-id="element-292">
                <QrCodeIcon size={qrSize} style={{
              color: qrColor
            }} data-id="element-293" />
              </div>
              <div className="flex justify-center space-x-3 mb-6" data-id="element-294">
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-md flex items-center" data-id="element-295">
                  <DownloadIcon size={18} className="mr-2" data-id="element-296" />
                  Download
                </button>
                <button className="bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg transition-colors flex items-center" data-id="element-297">
                  <CopyIcon size={18} className="mr-2" data-id="element-298" />
                  Copy
                </button>
              </div>
              <button onClick={handleComplete} className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg transition-colors shadow-md flex items-center justify-center" data-id="element-299">
                <CheckIcon size={18} className="mr-2" data-id="element-300" />
                Complete
              </button>
            </div> : <div className="text-center py-12" data-id="element-301">
              <QrCodeIcon size={100} className="mx-auto text-blue-800/30 mb-4" data-id="element-302" />
              <h3 className="text-lg font-medium text-white mb-1" data-id="element-303">
                QR Code Preview
              </h3>
              <p className="text-blue-300" data-id="element-304">
                Generate the QR code to see a preview
              </p>
            </div>}
        </div>
      </div>
      <div className="mt-6 bg-gradient-to-r from-purple-600/20 to-purple-700/20 backdrop-blur-sm border border-purple-500/30 rounded-xl p-5" data-id="element-305">
        <h3 className="text-lg font-bold text-white mb-3" data-id="element-306">
          QR Code Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-307">
          <div className="bg-white/10 rounded-lg p-3 flex items-center" data-id="element-308">
            <PercentIcon size={20} className="text-green-400 mr-2" data-id="element-309" />
            <div data-id="element-310">
              <div className="text-sm text-white font-medium" data-id="element-311">40% Discount</div>
              <div className="text-xs text-blue-300" data-id="element-312">Automatically applied</div>
            </div>
          </div>
          <div className="bg-white/10 rounded-lg p-3 flex items-center" data-id="element-313">
            <div size={20} className="text-blue-400 mr-2" data-id="element-314" />
            <div data-id="element-315">
              <div className="text-sm text-white font-medium" data-id="element-316">Kiosk Mode</div>
              <div className="text-xs text-blue-300" data-id="element-317">
                Optimized for displays
              </div>
            </div>
          </div>
          <div className="bg-white/10 rounded-lg p-3 flex items-center" data-id="element-318">
            <Share2Icon size={20} className="text-purple-400 mr-2" data-id="element-319" />
            <div data-id="element-320">
              <div className="text-sm text-white font-medium" data-id="element-321">Shareable</div>
              <div className="text-xs text-blue-300" data-id="element-322">Easy distribution</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}